<ng-container>
  <div class="field-container">
    <div class="label-container">
      <label class="form-label">{{labelText}}<span class="text-danger" *ngIf="required">*</span></label>
      <span *ngIf="maxLength" class="char-counter" [ngClass]="isMaxLengthExceeded ? 'text-danger' : 'text-muted'">
        {{characterCount}}/{{maxLength}}
      </span>
    </div>
    <input [value]="value" type="text" pInputText pSize="small" class="w-full" appendTo="body" [attr.data-key]="dataKey"
      [disabled]="disabled" autocomplete="off" [ngClass]="[recovery ? 'recover-data' : '', inputClass]"
      (input)="changeText($event)" (focus)="selectAllText($event)" (blur)="changeTextOnBlur($event)" />
  </div>
</ng-container>